import styles from './navbar.module.scss'
import { Link } from 'react-router-dom'
import Grid from '@mui/material/Grid'
import ButtonCustom from '../atoms/button/ButtonCustom'
import useMediaQuery from '@mui/material/useMediaQuery'
import React from 'react'
import Drawer from '@mui/material/Drawer'
import { NavItems } from './NavItems'
// Top navigation bar for the application
export const Navbar = () => {
	const isMobileScreen = useMediaQuery('(max-width:991px)')

	const [menuOpen, setMenuOpen] = React.useState(false)

	const toggleDrawer = (newOpen) => () => {
		setMenuOpen(newOpen)
	}
	return (
		<>
			<header className={`${styles.header}`}>
				<div className="container">
					<Grid
						container
						spacing={{ xs: 2 }}
						alignItems={'center'}
						justifyContent={'space-between'}
					>
						<Grid size={{ xs: 4, sm: 4, md: 2 }}>
							<Link to="/" className={styles.headerLogo}>
								<img
									src={'/images/ontimebridelogo.svg'}
									className={styles.logo}
									alt="logo"
								/>
							</Link>
						</Grid>
						<Grid size={{ xs: 8, sm: 8, md: 10 }}>
							<div className={styles.headerRight}>
								{isMobileScreen ? (
									<>
										<button
											className={styles.hamBurgerMenu}
											onClick={toggleDrawer(true)}
										>
											<img
												src="/images/hamburger-menu.svg"
												className=""
												alt=""
											/>
										</button>
										<Drawer
											open={menuOpen}
											onClose={toggleDrawer(false)}
											className={styles.drawerWrp}
											sx={{
												'& .MuiDrawer-paper': {
													backgroundColor: '#fff',
													maxWidth: '300px',
													width: '100%',
													p: '1.5rem',
												},
											}}
										>
											<div
												className={styles.drawerContent}
											>
												<button
													className={styles.closeIcn}
													onClick={toggleDrawer(
														false
													)}
												>
													<img
														src="/images/close-icon.svg"
														className=""
														alt=""
													/>
												</button>
												<NavItems />
											</div>
										</Drawer>
									</>
								) : (
									<NavItems />
								)}
								<div className={styles.headerBtns}>
									<ButtonCustom
										variant="outlined"
										to="/login"
										onClick={() => alert('Button Clicked!')}
										data-cy="go-to-login"
									>
										login
									</ButtonCustom>
                                    {
                                        process.env.REACT_APP_NODE_ENV === 'development' &&
                                        <ButtonCustom
                                            variant="default"
                                            to="/demo-login"
                                            onClick={() => alert('Button Clicked!')}
                                            data-cy="go-to-demo-login"
                                        >
                                            Demo Login{' '}
                                        </ButtonCustom>
                                    }
								</div>
							</div>
						</Grid>
					</Grid>
				</div>
			</header>
		</>
	)
}
